export const mainTheme = {
  palette: {
    primary: {
      50: "#EFFFEB",
      100: "#E2FFDB",
      200: "#C2FFB3",
      300: "#A5FF8F",
      400: "#89FF6B",
      500: "#69FF45",
      600: "#37FF05",
      700: "#27C200",
      800: "#198000",
      900: "#0D4200",
      A100: "#b9f6ca",
      A200: "#69f0ae",
      A400: "#00e676",
      A700: "#00c853",
      contrastText: "rgba(0, 0, 0, 0.87)",
      dark: "#69ff45",
      light: "#69ff45",
      main: "#69ff45",
    },
    secondary: {
      50: "#EFFFEB",
      100: "#E2FFDB",
      200: "#C2FFB3",
      300: "#A5FF8F",
      400: "#89FF6B",
      500: "#69FF45",
      600: "#37FF05",
      700: "#27C200",
      800: "#198000",
      900: "#0D4200",
      A100: "#b9f6ca",
      A200: "#69f0ae",
      A400: "#00e676",
      A700: "#00c853",
      contrastText: "rgba(0, 0, 0, 0.87)",
      dark: "#69ff45",
      light: "#69ff45",
      main: "#69ff45",
    }
  },
}


// WEBPACK FOOTER //
// ./src/theme/ddTheme.js